import api from "../../utils/ApiConfig";

export const fetchPosts = async (status = null, search = null, page = 1) => {
  const params = new URLSearchParams({ page });
  if (status) params.set("status", status);
  if (search)  params.set("search", search);
  const response = await api.get(`/bo/instagram/posts?${params}`);
  return response.data;
};

export const createPost = async (data) => {
  const response = await api.post("/bo/instagram/posts", data);
  return response.data;
};

export const updatePost = async (id, data) => {
  const response = await api.put(`/bo/instagram/posts/${id}`, data);
  return response.data;
};

export const deletePost = async (id) => {
  const response = await api.delete(`/bo/instagram/posts/${id}`);
  return response.data;
};

export const publishPost = async (id) => {
  const response = await api.post(`/bo/instagram/posts/${id}/publish`);
  return response.data;
};

export const recompact = async () => {
  const response = await api.post("/bo/instagram/recompact", {});
  return response.data;
};

export const bulkSchedule = async (startDate) => {
  const response = await api.post("/bo/instagram/bulk-schedule", { start_date: startDate });
  return response.data;
};

export const importCsv = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await api.post("/bo/instagram/import-csv", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};
